import { GetStaticProps } from 'next';

import hmhFrontpageImage from '../../assets/images/bluebonetfontpage.png';
import HMHIntoReadingLandingContent from '../../components/_organisms/HMHIntoReadingLandingContent';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import { DefaultLocale } from '../../providers/tolgee';

const HMHIntoReadingLandingPage = () => {
  return (
    <LandingPageLayout
      title="The Curipod + HMH Into Reading Texas"
      ogTitle="HMH Into Reading Texas is your curriculum. Curipod brings engagement, writing, and insights."
      subTitle="Research-based writing practice including SCRs, ECRs, Revision & editing and more."
      image={hmhFrontpageImage}
      disableHeadline={true}
    >
      <HMHIntoReadingLandingContent />
    </LandingPageLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      _tolgeeSSR: {
        language: DefaultLocale,
      },
    },
  };
};

export default HMHIntoReadingLandingPage;
